import { type FC, type ReactElement } from 'react';
import { Link, useParams } from 'react-router-dom';
import StudyHealthSetupForm from './Forms/StudyHealthSetupForm';

interface AgentFormConfig {
  label: string;
  render: () => ReactElement;
}

/** Maps agent slugs to their setup form config. */
const agentForms: Record<string, AgentFormConfig> = {
  pulse: { label: 'Study Health Check', render: () => <StudyHealthSetupForm /> },
};

/** Generic agent setup page. Resolves the form component by agent slug from the URL. */
const AgentSetupPage: FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const config = agentForms[slug ?? ''];

  return (
    <div className="ph4 pb4 pt3" data-testid="agent-setup-page">
      <div className="f5 mb3">
        <Link to="/agents" className="blue link">
          In Vivo AI
        </Link>
        <span className="mh1 mid-gray">/</span>
        <span className="near-black">{config?.label ?? 'Setup'}</span>
      </div>
      {config ? config.render() : <p className="mid-gray">Agent not found.</p>}
    </div>
  );
};

export default AgentSetupPage;
